import { ProtocoloEntidade } from "../../entidades/ProtocoloEntidade";
import { Alerta, Box, Botao, TipoBotao, TipoAlerta } from "@intechprev/componentes-web";
import { ComprovantesService } from "../../services/ComprovantesService";
import React from "react";
import { MasterPage } from "..";
import { NumFuncionalidade } from "../MasterPage";
import { reCAPTCHA } from "../../helpers";

interface Props {
  history?: any;
}

interface State {
  listaComprovantes: ProtocoloEntidade[];
  erro: string;
  loading: boolean;
}

export class Comprovantes extends React.Component<Props, State> {
  private recaptcha = new reCAPTCHA("comprovantes");

  private page = React.createRef<MasterPage>();

  constructor(props: Props) {
    super(props);

    this.state = {
      listaComprovantes: [],
      erro: "",
      loading: false,
    };
  }

  componentDidMount = async () => {
    await this.setState({ loading: true });

    try {
      let lista = await ComprovantesService.Buscar();
      await this.setState({ listaComprovantes: lista });
    } catch (err) {
      await this.setState({ erro: err.response ? err.response.data : err });
    } finally {
      await this.setState({ loading: false });
    }
  };

  render() {
    return (
      <MasterPage Funcionalidade={NumFuncionalidade.COMPROVANTES} ref={this.page} {...this.props}>
        {!this.state.loading && this.state.erro && <Alerta tipo={TipoAlerta.danger}>{this.state.erro}</Alerta>}
        {!this.state.loading && !this.state.erro && this.state.listaComprovantes.length === 0 && (
          <Alerta tipo={TipoAlerta.danger}>Você não possui comprovantes para consulta.</Alerta>
        )}

        {!this.state.loading && !this.state.erro && this.state.listaComprovantes.length > 0 && (
          <Box>
            <div className="table-responsive">
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>Data Solicitação</th>
                    <th>Funcionalidade</th>
                    <th>Protocolo</th>
                    <th>Situação</th>
                    <th>Data Efetivação</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.listaComprovantes.map((comprovante, index) => (
                    <tr key={index}>
                      <td>{comprovante.DTA_SOLICITACAO}</td>
                      <td>{comprovante.DES_FUNCIONALIDADE}</td>
                      <td>{comprovante.COD_IDENTIFICADOR}</td>
                      <td>
                        <strong>
                          {comprovante.DES_SITUACAO === "RECUSADO" && <span className="text-danger">{comprovante.DES_SITUACAO}</span>}
                          {comprovante.DES_SITUACAO === "EFETIVADO" && <span className="text-success">{comprovante.DES_SITUACAO}</span>}
                          {comprovante.DES_SITUACAO === "SOLICITADO" && <span className="text-info">{comprovante.DES_SITUACAO}</span>}
                        </strong>
                      </td>
                      <td>{comprovante.DTA_EFETIVACAO}</td>
                      <td>
                        <Botao
                          tipo={TipoBotao.primary}
                          titulo="Detalhar"
                          onClick={() => this.props.history.push(`/comprovantesDetalhe/${comprovante.OID_PROTOCOLO}`)}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Box>
        )}
      </MasterPage>
    );
  }
}
